import { useGetSystemSettingsQuery } from '@shared/services/systemSettings';

export const useSystemSettingsValue = (categories: string[]) => {
  const { data: systemSettings, isFetching } = useGetSystemSettingsQuery({
    Categories: categories,
  });

  const getValue = (category: string): string | undefined =>
    systemSettings?.find((s) => s.Category === category)?.Value;

  return { getValue, isFetching };
};
